import { render, staticRenderFns } from "./editaddress.vue?vue&type=template&id=01df0b76&scoped=true"
import script from "./editaddress.vue?vue&type=script&lang=js"
export * from "./editaddress.vue?vue&type=script&lang=js"
import style0 from "./editaddress.vue?vue&type=style&index=0&id=01df0b76&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01df0b76",
  null
  
)

export default component.exports